import application, { definitionsFromContext } from "lib/stimulus"

// Report charts load from their own `reports/charts` bundle.
const context = require.context("./", true, /^(?!\.\/reports\/chart_controller\.js$).*controller\.js$/)
application.load(definitionsFromContext(context))

import './ui/icon'
import './ui/select'
import './ui/field/input_group'
